import { FormState } from "./types";

export const INITIAL_FORM_STATE: FormState = {
  componentFields: {},
  componentFieldErrors: {},
  componentFieldMessages: {},
  formFields: {},
  formFieldErrors: {},
  formFieldMessages: {},
  categories: [],
  expandedCategoryIds: new Set(),
  expandedNestedIds: new Set(),
  selectedItemType: null,
  selectedCategoryId: null,
  selectedNestedId: null,
  selectedItemId: null,
  editingItemId: null,
  currentFieldsConfig: [],
  parentId: null,
  categoryMembershipIds: [],
};

export const SECTION_TYPES = {
  FAQ: "17",
  FOOTER: "18",
  VISIONARIES: "49",
} as const;

